module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_5010.ca71789e.png";